export * from './getMainBgColor'
export * from './getFocusBgColor'
export * from './getHoverBgColor'
export * from './getActiveBgColor'

export * from './getMainTextColor'
export * from './getFocusTextColor'
export * from './getHoverTextColor'
export * from './getActiveTextColor'
